// Events
import { MODAL_OPEN, VIDEO_PLAY } from 'events';
import { component } from 'picoapp';
import Swiper, {
  A11y,
  Autoplay,
  Keyboard,
  Manipulation,
  Mousewheel,
  Navigation,
  Scrollbar,
} from 'swiper';

// Utils
import choozy from 'utils/choozy';
import { mobileOnlyFunction } from 'utils/device';
import { hide, show } from 'utils/node';
import { dispatch } from 'utils/theme';

Swiper.use([A11y, Autoplay, Navigation, Manipulation, Mousewheel, Scrollbar, Keyboard]);

export default component(async (node, ctx) => {
  const {
    sliderMain,
    videoButtonThumb,
    thumbsBar,
    scrollbar,
    slide,
    thumbnail,
    overlay,
    moreButtonThumb,
  } = choozy(node);

  const slides = [].concat(slide);
  const thumbnails = [].concat(thumbnail);
  const videoButtons = [].concat(videoButtonThumb || []);

  const { fullscreenModalId } = node.dataset;

  const carousel = new Swiper(sliderMain, {
    slidesPerView: 1,
    speed: 200,
    breakpoints: {
      1024: {
        speed: 1300,
      },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    watchSlidesProgress: true,
    scrollbar: {
      el: scrollbar,
      draggable: true,
    },
  });

  const thumbsCarousel = new Swiper(thumbsBar, {
    slidesPerView: 7,
    direction: 'vertical',
    spaceBetween: 7,
  });

  carousel.on('slideChange', ({ activeIndex }) => {
    thumbsCarousel.slideTo(activeIndex);

    thumbnails.forEach((el) => {
      el.classList[+el.dataset.slideRef === activeIndex ? 'add' : 'remove']('active');
    });

    dispatch('pdp-change-main-image', { index: activeIndex });
  });

  thumbnails.forEach((el) => {
    el.addEventListener('click', () => {
      carousel.slideTo(+el.dataset.slideRef);
    });
  });

  videoButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const videoSlide = slides.find((s) => s.dataset.slideType === 'video');
      if (videoSlide) {
        carousel.slideTo(+videoSlide.dataset.slide);

        ctx.emit(VIDEO_PLAY, null, videoSlide.dataset.slideMediaId);
      }
    });
  });

  node.addEventListener('slider:touchStart', (e) => {
    if (e.detail.sliderEl === node) e.stopPropagation();
  });

  node.addEventListener('slider:touchEnd', (e) => {
    if (e.detail.sliderEl === node) e.stopPropagation();
  });

  node.addEventListener('video:play', () => {
    hide(overlay, scrollbar);
    mobileOnlyFunction(() => hide(thumbsBar));
  });

  node.addEventListener('video:ended', () => {
    show(overlay, scrollbar);
    mobileOnlyFunction(() => show(thumbsBar));
  });

  slides.forEach((s) => {
    const index = parseInt(s.dataset.slide, 10);
    const type = s.dataset.slideType;

    if (type === 'video') return;

    s.addEventListener('click', (e) => {
      if (!e.target.closest('[data-zoom-image]')) return;

      ctx.emit(MODAL_OPEN, null, {
        id: fullscreenModalId,
        props: {
          activeSlide: index,
        },
      });

      dispatch('pdp-enlarge-main-image');
    });
  });

  moreButtonThumb?.addEventListener('click', () => {
    ctx.emit(MODAL_OPEN, null, {
      id: fullscreenModalId,
      props: {
        activeSlide: 6,
      },
    });

    dispatch('pdp-enlarge-main-image');
  });
});
